(function () {
    'use strict';

    var module = angular.module('uwAgenda.global');
    module.directive('rfGlobalInfo', ['$state', '$translate', 'WebsocketService', 'WebsocketRegisterType', 'AgendaTransitionService', 'SharedAgendaService', RfGlobalInfoDirectiveFn]);

    // clickable information-message (like toastr)
    function RfGlobalInfoDirectiveFn($state, $translate, WebsocketService, WebsocketRegisterType, AgendaTransitionService, SharedAgendaService) {
        var directive = {
            restrict: 'E',
            link: link
        };
        return directive;

        function link(scope, element) {

            // websocket subscriber
            var taskInform = null;
            var appInform = null;

            activate();

            function activate() {
                registerWebsocket();
            } // activate

            // register websocket call
            function registerWebsocket() {
                // new task is added
                taskInform = WebsocketService.register(WebsocketRegisterType.TaskInform, function (jObject) {
                    // add action
                    task(jObject.data);
                });


                // new appointment is added
                appInform = WebsocketService.register(WebsocketRegisterType.AppointmentInform, function (jObject) {
                    // add action
                    appointment(jObject.data);
                });

            } // registerWebsocket 

            // show appointment information
            function appointment(item) {
                $translate('new_appointment').then(function (result) {

                    var html = "<div>" + result + "<p>" + item.patient + "</p>" + "<p>" + item.appointmentType + "</p>" + "<p>" + item.formattedAppointmentDate + "</p></div>";

                    toastr.options.onclick = function () {
                        // go to agenda-view
                        toAgenda(item.fK_Agenda, item.appointmentDate);
                    };

                    toast(html);
                });
            }


            // show task information
            function task(task) {
                $translate('action_by').then(function (result) {
                    // alert last-reaction (last item)
                    var reaction = task.reactions[task.reactions.length - 1];
                    var html = '<div>' + result + " " + reaction.userCaption + ': ' + reaction.content + '</div>';

                    toastr.options.onclick = function () {
                        // go to agenda-view
                        toAgenda(task.fK_Agenda, task.pinnedToDate || new Date());
                    };

                    toast(html);
                });

            }

            // to agenda
            function toAgenda(agendaId, date) {
                // go to agenda-view
                $state.go("Home.Agenda_Day");
                // agenda
                var agenda = SharedAgendaService.getAgenda(agendaId);
                if (agenda === undefined || agenda === null) { return; }
                // switch to agenda
                AgendaTransitionService.change(agenda.owner.id, date);
            }


            // toast
            function toast(html) {
                // options set
                var defaultTimeOut = toastr.options.timeOut;
                toastr.options.timeOut = 10000;
                toastr.options.closeButton = true;
                toastr.info(html);
                toastr.options.timeOut = defaultTimeOut; // default
            }


            // destroy
            scope.$on("$destroy", function () {
                if (taskInform) { WebsocketService.unregister(taskInform.id); }
                if (appInform) { WebsocketService.unregister(appInform.id); }
                // toastr.clear();
            });


        }

    }

})();